
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patron-pass",
      function () {
        return require("private-next-pages/patron-pass.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patron-pass"])
      });
    }
  